"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class NetbillingPurchaseProvider extends DataProvider_1.default {
    assignCreditCard({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("netbillingAssignCreditCard", { data }, this.getFragment("CreditCardAssignment"));
        });
    }
    purchaseDeposit({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("netbillingPurchaseDeposit", { data }, this.getFragment("Transaction"));
        });
    }
    purchaseRecurring({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("netbillingPurchaseRecurring", { data }, this.getFragment("SubscriptionDetails"));
        });
    }
}
exports.NetbillingPurchaseProvider = NetbillingPurchaseProvider;
//# sourceMappingURL=NetbillingPurchaseProvider.js.map